import React, { useState, useRef, useEffect } from "react";
import { LayoutHome } from "../LayoutHome";
import { Input, Button, Card, Table, Space, notification, message } from "antd";
import {
  EditOutlined,
  SearchOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Text, Checkbox, Tag, ButtonGroup } from "rsuite";
import { FaPlus, FaSave } from "react-icons/fa";
import { getListaMaquinas, saveMaquina } from "../Services/CatalogosServices";
import { exportToExcel } from "../../Utils";
import { CSVLink } from "react-csv";
import { useReactToPrint } from "react-to-print";

export const MaquinasDialisis = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idMaq, setIdMaq] = useState(0);
  const [identif, setIdentif] = useState("");
  const [nombre, setNombre] = useState("");
  const [descrip, setDescrip] = useState("");
  const [modelo, setModelo] = useState("");
  const [serie, setSerie] = useState("");
  const [marca, setMarca] = useState("");
  const [deResp, setDeResp] = useState(0);
  const [usoPositivo, setUsoPositivo] = useState(0);
  const [activo, setActivo] = useState(1);
  const [data, setData] = useState([]);

  const [api, contextHolder] = notification.useNotification();
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const initialized = useRef(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Identificador",
      dataIndex: "identif",
      width: "8%",
      key: "idMaq",
      sorter: (a, b) => a.identif.length - b.identif.length,
      ...getColumnSearchProps("identif"),
    },
    {
      title: "Nombre del equipo",
      dataIndex: "nombre",
      width: "20%",
      key: "idMaq",
      ...getColumnSearchProps("nombre"),
      sorter: (a, b) => a.nombre.length - b.nombre.length,
    },
    {
      title: "De respaldo",
      dataIndex: "deResp",
      width: "5%",
      key: "idMaq",
      align: "center",
      ...getColumnSearchProps("deResp"),
      render: (text) =>
        text === 1 ? <Tag color="green">Si</Tag> : <Tag color="#000">No</Tag>,
    },

    {
      title: "Uso Positivo",
      dataIndex: "usoPositivo",
      width: "5%",
      key: "idMaq",
      align: "center",
      ...getColumnSearchProps("usoPositivo"),
      render: (text) =>
        text === 1 ? <Tag color="red">Si</Tag> : <Tag color="#000">No</Tag>,
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      width: "30%",
      key: "idMaq",
    },
    {
      title: "Modelo",
      dataIndex: "modelo",
      width: "20%",
      key: "idMAq",
    },
    {
      title: "Serie",
      dataIndex: "serie",
      width: "10%",
      key: "idMaq",
      align: "center",
    },
    {
      title: "Marca",
      dataIndex: "marca",
      width: "10%",
      key: "idMaq",
      align: "center",
    },
    {
      title: "Estatus",
      dataIndex: "activo",
      width: "5%",
      key: "idMaq",
      align: "center",
      render: (text) =>
        text === 1 ? (
          <Tag color="green">Activo</Tag>
        ) : (
          <Tag color="red">Inactivo</Tag>
        ),
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "5%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<EditOutlined />}
          color="primary"
          variant="outlined"
          onClick={() =>
            edit({
              idMaq: record.idMaq,
              identif: record.identif,
              nombre: record.nombre,
              descripcion: record.descripcion,
              modelo: record.modelo,
              serie: record.serie,
              marca: record.marca,
              deResp: record.deResp,
              usoPositivo: record.usoPositivo,
              activo: record.activo,
            })
          }
        ></Button>
      ),
    },
  ];

  const edit = (props) => {
    console.log(props.descripcion);
    setIdMaq(props.idMaq);
    setNombre(props.nombre);
    setIdentif(props.identif);
    setDescrip(props.descripcion);
    setModelo(props.modelo);
    setSerie(props.serie);
    setMarca(props.marca);
    setUsoPositivo(props.usoPositivo);
    setDeResp(props.deResp);
    setActivo(props.activo);
  };

  const handleExport = () => {
    // Use the same data source that you pass to the antd Table component
    exportToExcel(data, "Maquinas_Dialisis");
  };

  const checkActivo = (e) => {
    if (e.target.checked) {
      setActivo(1);
    } else {
      setActivo(0);
    }
  };

  const checkRespaldo = (e) => {
    if (e.target.checked) {
      setDeResp(1);
    } else {
      setDeResp(0);
    }
  };

  const checkUsoPositivo = (e) => {
    if (e.target.checked) {
      setUsoPositivo(1);
    } else {
      setUsoPositivo(0);
    }
  };

  const loadMaquinas = async () => {
    await getListaMaquinas(idNegocio)
      .then((res) => {
        setData(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const save = async () => {
    if (identif.length === 0) {
      errorNotificaction(
        "Identificador",
        "El campo identificador no puede estar vacio...",
      );
      return;
    }
    if (nombre.length === 0) {
      errorNotificaction("Nombre", "El nombre no puede estar vacio...");
      return;
    }
    const data = {
      IdConsultorio: idNegocio,
      IdMaquina: idMaq,
      Identificador: identif,
      Nombre: nombre,
      Descrip: descrip,
      Modelo: modelo,
      Serie: serie,
      Marca: marca,
      DeResp: deResp,
      UsoPositivo: usoPositivo,
      Activo: activo,
    };

    await saveMaquina(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Maquina de Diálisis",
            "Se ha registrado la información de forma correcta.",
          );
          setTimeout(() => {
            setIdMaq(0);
            window.location.reload();
          }, 1000);
          setIdMaq(0);
        } else {
          errorNotificaction(
            "Error",
            "Ocurrio un error al enviar la información.",
          );
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadMaquinas();
    }
  }, []);

  return (
    <>
      <title>Maquinas de Diálisis - NefroSys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Inicio
              </a>
            ),
          },
          { title: "Maquinas de Diálisis" },
        ]}
        selectedKey={"1.4"}
      >
        {contextHolder}
        <Card title="Alta de Equipo">
          <div className="row mb-2">
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>
                <b style={{ color: "red" }}>*</b> Indentificador
              </Text>
              <Input
                value={identif}
                onChange={(e) => setIdentif(e.target.value)}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3">
              <Text>
                <b style={{ color: "red" }}>*</b> Nombre del equipo
              </Text>
              <Input
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>
            <div className="col-lg-5 col-md-5 col-sm-5">
              <Text>Descripción</Text>
              <Input
                value={descrip}
                onChange={(e) => setDescrip(e.target.value)}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Modelo</Text>
              <Input
                value={modelo}
                onChange={(e) => setModelo(e.target.value)}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-lg-3 col-md-3 col-sm-3">
              <Text>Serie</Text>
              <Input value={serie} onChange={(e) => setSerie(e.target.value)} />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3">
              <Text>Marca</Text>
              <Input value={marca} onChange={(e) => setMarca(e.target.value)} />
            </div>
            <div className="text-center col-lg-1 col-md-1 col-sm-1">
              <Text>De respaldo</Text>
              <Checkbox
                onClick={(e) => checkRespaldo(e)}
                checked={deResp === 1 ? true : false}
              />
            </div>
            <div className="text-center col-lg-1 col-md-1 col-sm-1">
              <Text>Uso positivo</Text>
              <Checkbox
                onClick={(e) => checkUsoPositivo(e)}
                checked={usoPositivo === 1 ? true : false}
              />
            </div>
            <div className="text-center col-lg-2 col-md-2 col-sm-2">
              <Text>Activo</Text>
              <Checkbox
                onClick={(e) => checkActivo(e)}
                checked={activo === 1 ? true : false}
              />
            </div>
            <div className="text-end col-lg-2 col-md-2 col-sm-2">
              <br></br>
              <ButtonGroup divided vertical>
                <Button
                  icon={<FaPlus></FaPlus>}
                  onClick={() => window.location.reload()}
                  color="primary"
                  variant="outlined"
                >
                  Nuevo
                </Button>
                &nbsp;
                <Button icon={<FaSave></FaSave>} onClick={save} type="primary">
                  Guardar
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </Card>
        <br></br>
        <Card title="Equipos de Diálisis">
          <div className="row">
            <div className="col">
              {/* <Space style={{ float: "right" }}>
      <Button
        onClick={handleExport}
        icon={<ExportOutlined></ExportOutlined>}
        color="primary"
        variant="outlined"
        style={{ marginBottom: 16 }}
      >
        Exportar a Excel
      </Button>
    </Space> */}
              <Table
                bordered
                size="small"
                rowKey={(record) => record.idEnf}
                columns={columns}
                dataSource={data}
                pagination={{ pageSize: 5 }}
              />
            </div>
          </div>
        </Card>
      </LayoutHome>
    </>
  );
};
